import { render, staticRenderFns } from "./b1.vue?vue&type=template&id=193ba718&scoped=true&"
import script from "./b1.vue?vue&type=script&lang=js&"
export * from "./b1.vue?vue&type=script&lang=js&"
import style0 from "./b1.vue?vue&type=style&index=0&id=193ba718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ba718",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('193ba718')) {
      api.createRecord('193ba718', component.options)
    } else {
      api.reload('193ba718', component.options)
    }
    module.hot.accept("./b1.vue?vue&type=template&id=193ba718&scoped=true&", function () {
      api.rerender('193ba718', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aliApp/xcxPos/business/b1.vue"
export default component.exports